<script setup>
import { defineEmits, defineProps, ref } from "vue";

const emits = defineEmits(["update:modelValue"]);
const props = defineProps({
    modelValue: {
        type: String,
        default: "",
        validator(value) {
            return ["", "dog", "cat"].includes(value);
        },
    }
})

import IconDog from "../svg/IconDog.vue";
import IconCat from "../svg/IconCat.vue";
</script>

<template>
    <div>
        <p class="text-base font-medium text-white" v-html="$t('form.species')"></p>

        <fieldset class="mt-1 mb-6">
            <legend class="sr-only">{{ $t('form.species') }}</legend>
            <div class="flex items-center space-x-6">
                <div class="flex items-center">
                    <input id="specieDog" name="species" type="radio"
                           class="h-4 w-4 border-gray-300 text-bi-accent-green focus:ring-bi-accent-green"
                           :checked="modelValue === 'dog'"
                           @change="emits('update:modelValue', 'dog')"
                    />
                    <label for="specieDog" :title="$t('form.species.dog')"
                           class="ml-3 block text-sm font-bold text-white">
                        <!-- <icon-dog :checked="modelValue === 'dog'"></icon-dog> -->

                        <span> {{ $t('form.species.dog') }}</span>
                    </label>
                </div>

                <div class="flex items-center">
                    <input id="specieCat" name="species" type="radio"
                           class="h-4 w-4 border-gray-300 text-bi-accent-green focus:ring-bi-accent-green"
                           :checked="modelValue === 'cat'"
                           @change="emits('update:modelValue', 'cat')"
                    />
                    <label for="specieCat" :title="$t('form.species.cat')"
                           class="ml-3 block text-sm font-bold text-white">
                        <!-- <icon-cat :checked="modelValue === 'cat'"></icon-cat> -->

                        <span>{{ $t('form.species.cat') }}</span>
                    </label>
                </div>
            </div>
        </fieldset>
    </div>
</template>
